import React from 'react';
import { Link } from 'react-router-dom';
import SectionTitle from '../../components/SectionTitle/SectionTitle';
import Card from '../../components/Card/Card';
import Button from '../../components/Button/Button';
import styles from './About.module.css';

const About = () => {
  return (
    <div className={styles.about}>
      {/* Hero / Page Header */}
      <section className={styles.header}>
        <h1 className={styles.pageTitle}>WHO WE ARE</h1>          {/* 👈 changed */}
        <p className={styles.pageSubtitle}>Uniting medical professionals for a healthier Idoma nation</p>
      </section>

      {/* Mission Section */}
      <section className={styles.mission}>
        <div className={styles.missionGrid}>
          <div className={styles.missionContent}>
            <SectionTitle title="Our Mission" subtitle="Purpose" />
            <p className={styles.missionText}>
              To be the umbrella body for all Medical Doctors of Idoma extraction, promoting their general interest and fostering unity. We encourage programs and projects that bring about the overall development of the Idoma nation, and provide a forum for engagement with government and international organisations on issues affecting the health and wellbeing of our people.
            </p>
            <p className={styles.missionText}>
              <strong>Motto:</strong> “Towards a Healthy Idoma Nation”
            </p>
          </div>
          <div className={styles.missionImage}>
            {/* Placeholder for an image representing mission */}
          </div>
        </div>
      </section>

      {/* History Section */}
      <section className={styles.history}>
        <SectionTitle title="Our History" subtitle="Founded on vision" align="center" />
        <div className={styles.historyContent}>
          <p>
            The Idoma Medical Doctors Foundation (IMDF) was established by a group of visionary medical doctors of Idoma extraction, led by Founding Chairman <strong>Dr. Francis Uba</strong> and Secretary General <strong>Dr. Michael A. Amedu</strong>. Recognising the need for a unified body to advocate for health and development in Idoma land, they drafted the constitution that still guides the foundation today.
          </p>
          <p>
            Since its inception, IMDF has grown to include hundreds of members across Nigeria and the diaspora, organising medical outreaches, publishing the <em>Journal of Medical Research and Practice</em>, and engaging with policymakers to improve healthcare delivery in the Idoma nation.
          </p>
        </div>
      </section>

      {/* Core Values */}
      <section className={styles.values}>
        <SectionTitle title="Our Core Values" subtitle="What we stand for" align="center" />
        <div className={styles.cardGrid}>
          <Card title="Unity" variant="elevated">
            <p>Bringing together medical professionals of Idoma origin, regardless of rank, gender, religion, or political affiliation.</p>
          </Card>
          <Card title="Development" variant="elevated">
            <p>Driving projects and programs that foster the overall development of the Idoma nation.</p>
          </Card>
          <Card title="Advocacy" variant="elevated">
            <p>Engaging with government and international bodies on issues affecting the health and wellbeing of our people.</p>
          </Card>
          <Card title="Excellence" variant="elevated">
            <p>Promoting high standards in medical practice, research, and community service.</p>
          </Card>
        </div>
      </section>

      {/* Constitution Summary */}
      {/* <section className={styles.constitution}>
        <div className={styles.constitutionBox}>
          <h3>Our Constitution</h3>
          <p>
            The IMDF Constitution outlines the governance structure, membership criteria, duties of officers, and the principles that guide our foundation. It is the supreme document binding all members.
          </p>
          <Link to="/constitution">
            <Button variant="outline" size="medium">Read the Full Constitution</Button>
          </Link>
        </div>
      </section> */}

      {/* Call to Action */}
      <section className={styles.cta}>
        <SectionTitle title="Join Us" subtitle="Become a member" light align="center" />
        <p className={styles.ctaText}>
          If you are a medical or dental practitioner of Idoma extraction, we invite you to join our community and contribute to the health and development of our nation.
        </p>
        <Link to="/membership">
          <Button variant="primary" size="large">Learn About Membership</Button>
        </Link>
      </section>
    </div>
  );
};

export default About;